import { render } from "./WorkScreenPage.vue?vue&type=template&id=77393c7b&scoped=true"
import script from "./WorkScreenPage.vue?vue&type=script&lang=js"
export * from "./WorkScreenPage.vue?vue&type=script&lang=js"

import "./WorkScreenPage.vue?vue&type=style&index=0&id=77393c7b&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77393c7b"]])

export default __exports__